import { GraphhopperConfiguration } from "./graphhopper-configuration";
import { GraphhopperCustomer } from "./graphhopper-customer";

export class GraphhopperRequest {
  
  configuration : GraphhopperConfiguration = new GraphhopperConfiguration();
  customers : GraphhopperCustomer[] = [];

}

